import type { CountryData } from "@qendo/types";
import type { Dispatch, SetStateAction } from "react";
import { ComboBox, type ComboBoxProps } from "~/components/form/combo-box/ComboBox";
import { useSystemOptions } from "~/providers/SystemOptionsProvider";

const mapCountries = (country: CountryData) => ({
    value: country.code,
    label: country.name,
});

export type CountrySelectorProps = {
    value: string | null;
    onItemSelected: ((v: string | null) => void) | Dispatch<SetStateAction<string | null>>;
    searchable?: true;
    addable?: never;
    onAddItem?: never;
} & Partial<ComboBoxProps<string, CountryData>>;

export function CountrySelector({ label = "Country", value, onItemSelected, ...comboProps }: CountrySelectorProps) {
    const { countries } = useSystemOptions();

    return (
        <ComboBox<string, CountryData>
            {...comboProps}
            value={value}
            onItemSelected={onItemSelected}
            items={countries}
            mapItems={mapCountries}
            label={label}
            searchable
            addable={false}
            onAddItem={undefined}
        />
    );
}
